"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
var auth_1 = require("@aws-amplify/auth");
var API = (function () {
    function API(baseUrl, sandboxHeader) {
        this.baseUrl = baseUrl;
        this.sandboxHeader = sandboxHeader;
    }
    API.prototype.request = function (resource, config) {
        var _this = this;
        return auth_1.Auth.currentSession().then(function (credentials) {
            var defaultConfig = {
                credentials: 'include',
                headers: __assign({ Authorization: "Cognito " + credentials
                        .getIdToken()
                        .getJwtToken() }, (_this.sandboxHeader === 'TRUE' ? { 'Element-Sandbox': "true" } : _this.sandboxHeader === 'FALSE' ? { 'Element-Sandbox': "false" } : {})),
            };
            var init = Object.assign({}, defaultConfig, config);
            if (init.body) {
                init = setBody(init);
            }
            return fetch(_this.baseUrl + resource, init)
                .then(function (response) {
                return response.text().then(function (text) { return ({
                    status: response.status,
                    ok: response.ok,
                    data: parseData(response.headers.get('Content-Type'), text),
                }); });
            })
                .then(_this.checkStatus)
                .catch(_this.handleError);
        });
    };
    API.prototype.delete = function (resource) {
        return this.getShorthand('DELETE', resource);
    };
    API.prototype.get = function (resource) {
        return this.getShorthand('GET', resource);
    };
    API.prototype.patch = function (resource, body) {
        return this.getShorthand('PATCH', resource, body);
    };
    API.prototype.post = function (resource, body) {
        return this.getShorthand('POST', resource, body);
    };
    API.prototype.put = function (resource, body) {
        return this.getShorthand('PUT', resource, body);
    };
    API.prototype.getBlob = function (resource) {
        var _this = this;
        return auth_1.Auth.currentSession().then(function (credentials) {
            var config = {
                credentials: 'include',
                method: 'GET',
                headers: __assign({ Authorization: "Cognito " + credentials.getIdToken().getJwtToken() }, (_this.sandboxHeader === 'TRUE' ? { 'Element-Sandbox': "true" } : _this.sandboxHeader === 'FALSE' ? { 'Element-Sandbox': "false" } : {})),
            };
            return fetch(_this.baseUrl + resource, config)
                .then(function (response) {
                return response.blob().then(function (blob) { return ({
                    status: response.status,
                    ok: response.ok,
                    data: blob,
                }); });
            })
                .then(_this.checkStatus)
                .catch(_this.handleError);
        });
    };
    API.prototype.checkStatus = function (response) {
        return response.ok ? response.data : Promise.reject(response);
    };
    API.prototype.handleError = function (err) {
        throw err;
    };
    API.prototype.getShorthand = function (method, resource, body) {
        var config = body
            ? {
                method: method,
                body: body,
            }
            : {
                method: method,
            };
        return this.request(resource, config);
    };
    return API;
}());
exports.API = API;
function setBody(init) {
    var body = init.body;
    if (isArrayBuffer(body) || isBlob(body) || isFormData(body)) {
        return init;
    }
    if (isURLSearchParams(body)) {
        return _setBodyAndContentType(init, body.toString(), 'application/x-www-form-urlencoded;charset=utf-8');
    }
    if (isObject(body)) {
        return _setBodyAndContentType(init, JSON.stringify(body), 'application/json;charset=utf-8');
    }
    return init;
}
function parseData(contentType, text) {
    if (text &&
        contentType &&
        contentType.toLowerCase().indexOf('application/json') > -1) {
        return JSON.parse(text);
    }
    return text || null;
}
function _setBodyAndContentType(init, body, contentType) {
    return Object.assign({}, init, { body: body }, {
        headers: Object.assign({}, init.headers, {
            'Content-Type': contentType,
        }),
    });
}
function isArrayBuffer(val) {
    return Object.prototype.toString.call(val) === '[object ArrayBuffer]';
}
function isBlob(val) {
    return Object.prototype.toString.call(val) === '[object Blob]';
}
function isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isURLSearchParams(val) {
    return (typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams);
}
//# sourceMappingURL=ApiImplementation.js.map